import React from 'react';
import { BsPlus } from 'react-icons/bs';
import { useDispatch } from 'react-redux';
import { Icon, IconButton } from '@chakra-ui/react';

import { showModal } from '../../../../../redux/modules/modal';
import Content from '../Content';

function ModalButton() {
  const dispatch = useDispatch();
  return (
    <IconButton
      icon={<Icon as={BsPlus} boxSize={5} />}
      size="xs"
      variant="textPrimary"
      onClick={() => {
        dispatch(showModal(() => (
          <Content type="modal" />
        ), {
          size: '6xl',
          maxWidth: { lg: '767px', sm: '90%' }
        }));
      }}
    />
  );
}

export default ModalButton;
